<template>
  <div>
    <b-container>
      <label style="font-size: 30px">Vouchers [{{used}} / {{vouchers.length}}]</label>
    </b-container>
    <b-table striped hover :items="vouchers" :fields="fields">
      <template v-slot:cell(status)="row">
        <div v-if="row.item.status == 'used'">
          <font-awesome-icon icon="check" :style="{ color: 'green' }" />
        </div>
      </template>

      <template v-slot:cell(show_details)="row">
        <b-button
          size="sm"
          @click="row.toggleDetails"
          class="mr-2"
        >{{ row.detailsShowing ? 'Hide' : 'Show'}}</b-button>
      </template>

      <template v-slot:row-details="row">
        <b-card>
          <b-row class="mb-2">
            <b-col>
              <pre style="text-align: left">{{ row.item.activity_log_json | pretty }}</pre>
            </b-col>
          </b-row>
        </b-card>
      </template>
    </b-table>
  </div>
</template>

<script>
import { db } from "../firebase";
import _ from "lodash";

export default {
  data() {
    return {
      fields: ["nfc_uid", "email", "amount", "status", "show_details"],
      vouchers: [],
      used: 0
    };
  },
  firebase: {
    vouchers: db.ref("vouchers")
  },
  filters: {
    pretty: value => {
      return JSON.stringify(JSON.parse(value), null, 2);
    }
  },
  watch: {
    vouchers: function(value) {
      this.used = _.filter(value, { status: "used" }).length;
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 60px;
}
</style>
